// extracted by mini-css-extract-plugin
export default {"app-notched-outline-idle":"c6455c","app-notched-outline-idle--notched":"c23cfc","app-notched-outline-idle--hidden":"c481f1"};